import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';

import { Duration, Instant, Role } from 'src/app/services/jsonrpc/user-server.service';

export interface UserMultiModalConfig {
  title: string;
  state: boolean;
  duration: boolean;
}

export interface UserMultiModalResult {
  toggleEnabled: boolean;
  toggleRoles: boolean;
  toggleExpiration: boolean;
  toggleDuration: boolean;
  enabled: boolean;
  roles: string[];
  expiration?: Instant;
  duration?: Duration;
}

@Component({
  selector: 'app-user-multi-modal',
  templateUrl: './user-multi-modal.component.html',
  styleUrls: ['./user-multi-modal.component.scss']
})
export class UserMultiModalComponent implements OnInit {
  @Input() public config: UserMultiModalConfig;
  @Input() public roles: Role[] = [];
  @Output() onSubmit = new EventEmitter<UserMultiModalResult>();

  public state: UserMultiModalResult = {
    toggleEnabled: false,
    toggleRoles: false,
    toggleExpiration: false,
    toggleDuration: false,
    enabled: true,
    roles: [],
    expiration: null,
    duration: null
  };
  public _expiration: NgbDate = null;

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}

  public isValid(): boolean {
    return this.isChange() && this.isValidRoles() && this.isValidDuration();
  }

  public submit() {
    if (this.state.toggleDuration && this.state.duration != null) {
      this.state.toggleExpiration = true; // duration is set - clear expiration
      this.state.expiration = null;
    }
    if (this.state.toggleExpiration && this.state.expiration != null) {
      this.state.toggleDuration = true; // expiration is set - clear duration
      this.state.duration = null;
    }

    this.onSubmit.emit({
      ...this.state,
      expiration: this.ngbDateToInstant(this._expiration)
    });
    this.modal.close();
  }

  public isChange(): boolean {
    return this.state.toggleEnabled || this.state.toggleRoles || this.state.toggleExpiration || this.state.toggleDuration;
  }

  public isValidRoles(): boolean {
    return !this.state.toggleRoles || this.state.roles.length > 0;
  }

  public isValidDuration(): boolean {
    return (
      !this.state.toggleDuration ||
      this.state.duration == null ||
      (this.state.duration as string).match(
        /^P(?!$)(\d+(\.\d+)?Y)?(\d+(\.\d+)?M)?(\d+(\.\d+)?W)?(\d+(\.\d+)?D)?(T(?=\d)(\d+(\.\d+)?H)?(\d+(\.\d+)?M)?(\d+(\.\d+)?S)?)?$/
      ) != null
    );
  }

  private ngbDateToInstant(d: NgbDate): Instant {
    if (d) {
      return new Date(d.year, d.month - 1, d.day).toJSON();
    } else {
      return null;
    }
  }
}
